import useTransactionListStateContext from './useTransactionListStateContext';

export default function useHasAuxToDisputeTransaction() {
  const { hasRoleInArrayForActiveProgram } = useTransactionListStateContext();

  return !!hasRoleInArrayForActiveProgram([
    'cardholder-support',
    'supplier-payments-manager',
    'program-admin',
    'marqeta-admin-internal',
    'compliance-internal',
    'compliance-program-managed',
    'compliance-processor-only',
    'risk-internal',
    'aux-risk-external',
  ]);
}
